import {ChatInHeaderRef} from './ChatInHeader';

//для управления чатом
let globalChatRef: ChatInHeaderRef | null = null;

export const setChatRef = (ref: ChatInHeaderRef | null) => {
    globalChatRef = ref;
};

export const getChatRef = () => globalChatRef;

export const openChatWithUser = (username: string) => {
    globalChatRef?.openChatWithUser(username);
};

export const isChatOpen = () => {
    return globalChatRef?.isChatOpen() ?? false;
};
